<template lang="pug">

    .ui.modal(:class="{ fullscreen: fullscreen }" :style="modalStyle" ref="modal")

        .header(v-if="!hideHeader")
            slot(name='header')

        .scrolling.content
            slot(name='content')

        .actions(v-if="!hideFooter")
            slot(name='footer')

</template>

<script>

    export default {

        mounted() {
            $(this.$el).modal({
                allowMultiple: this.allowMultiple,
                blurring: this.blurring,
                transition: this.transition,
                onVisible: () => this.$emit('opened'),
                onHidden: () => this.$emit('closed'),
            })

            const contentEl = this.$el.querySelector('.scrolling.content')
            if (contentEl) {
                this._dropdownObserver = new MutationObserver(() => {
                    const openMenu = this.$el.querySelector('.ui.dropdown.active .menu.visible, .ui.dropdown.active.visible .menu')
                    if (openMenu) {
                        const menuRect    = openMenu.getBoundingClientRect()
                        const contentRect = contentEl.getBoundingClientRect()
                        const overflow    = menuRect.bottom - contentRect.bottom
                        if (overflow > 0) {
                            const current = parseInt(contentEl.style.minHeight) || contentEl.offsetHeight
                            contentEl.style.minHeight = (current + overflow + 16) + 'px'
                        }
                    } else {
                        contentEl.style.minHeight = ''
                    }
                })
                this._dropdownObserver.observe(this.$el, {
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                })
            }
        },

        beforeDestroy() {
            if (this._dropdownObserver) {
                this._dropdownObserver.disconnect()
            }
            $(this.$el).modal('destroy')
        },

        computed: {

            modalStyle() {
                if (this.fullscreen) return {}
                if (this.customWidth) return { width: this.customWidth }
                return { width: '75%' }
            }

        },

        methods: {

            close() {
                $(this.$el).modal('hide')
            },

            show() {
                $(this.$el).modal('show')
            },

        },

        props: {

            fullscreen: {
                type: Boolean,
                default: false
            },

            customWidth: {
                type: String,
                default: null
            },

            hideFooter: {
                type: Boolean,
                default: false
            },

            hideHeader: {
                type: Boolean,
                default: false
            },

            allowMultiple: {
                type: Boolean,
                default: false
            },

            blurring: {
                type: Boolean,
                default: true
            },

            transition: {
                type: Object,
                default: () => ({
                    showMethod   : 'fade up',
                    showDuration : 500,
                    hideMethod   : 'fade down',
                    hideDuration : 500,
                })
            }

        }

    }

</script>
